import i18n from "i18next";
import type { FC } from "react";
import { useNavigate } from "react-router";

import type { ManualDasConfigurationEntity } from "src/app/features/ManualDasConfiguration/types/ManualDasConfigurationEntity";
import { PrimaryButton } from "../../../../../components/Buttons/components/ActionButton";
import type { ButtonProps } from "../../../../../components/FeatureButtons/types";
import { ResourceName } from "../../../../../core/router/config/ResourceName";
import { BASE_PATH } from "../../../../../core/router/types/routerTypes";

export const ChangeButton: FC<ButtonProps<ManualDasConfigurationEntity>> = ({ item }) => {
    const navigate = useNavigate();
    const onClick = () => {
        navigate(`${BASE_PATH}/${ResourceName.MANUAL_DAS_CONFIGURATION}/switch`, { state: { config: item } });
    };

    return (
        <PrimaryButton name="change_button" onClick={onClick} disabled={false}>
            {i18n.t("button.change")}
        </PrimaryButton>
    );
};
